import { useState } from 'react';

import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';

import ByJobTab from './ByJobTab';
import FeedsTab from './FeedsTab';
import AllRunsTab from './AllRunsTab';

const TABS = [
  { key: 'by_job', label: 'By job' },
  { key: 'feeds', label: 'Feeds & data' },
  { key: 'all_runs', label: 'All runs' },
];

export default function TaskLoggerPage() {
  const [tab, setTab] = useState('by_job');
  // Deep-link target: a task family the user jumped to from By job / Feeds.
  const [drillFamily, setDrillFamily] = useState('');

  const drillToRuns = (family) => {
    setDrillFamily(family || '');
    setTab('all_runs');
  };

  return (
    <Box sx={{ flex: '1 1 auto', p: 2 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Task Activity
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Background jobs grouped by type, feed health with plain-English diagnoses, and the raw run log.
          </Typography>
        </Box>

        <Tabs value={tab} onChange={(_, val) => setTab(val)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
          {TABS.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} />
          ))}
        </Tabs>

        {tab === 'by_job' && <ByJobTab onDrillToRuns={drillToRuns} />}
        {tab === 'feeds' && <FeedsTab onDrillToRuns={drillToRuns} />}
        {tab === 'all_runs' && <AllRunsTab initialSearch={drillFamily} />}
      </Stack>
    </Box>
  );
}
